import React from "react";
import { useSelector } from "react-redux";
import defaultLogo from "../images/logos/aduppankarailogo-removebg.png";
import "./Logo.scss"; // Importing styles
import { getStoreInfo } from "../../utils/utils";

const Logo = () => {
  const reduxRestaurantInfo = useSelector((state) => state.data?.restaurantInfo);
  const storeInfo = reduxRestaurantInfo || getStoreInfo();
  const [imgError, setImgError] = React.useState(false);

  React.useEffect(() => {
    setImgError(false);
  }, [storeInfo?.logo]);

  const logoSrc = storeInfo?.logo && !imgError ? storeInfo.logo : defaultLogo;

  return (
    <div className="logo-container">
      <img
        className="logo-icon rounded-3"
        src={logoSrc}
        alt={storeInfo?.name || "Aduppankarai Logo"}
        onError={() => setImgError(true)}
      />
    </div>
  );
};

export default Logo;
